import { z } from "zod";
export const UI_SIDEBAR_MIN_WIDTH_PX = 208;
export const UI_SIDEBAR_MAX_WIDTH_PX = 384;
export const UI_SIDEBAR_DEFAULT_WIDTH_PX = 248;
/**
 * How the collected-data library draws an item's attachments: folded under the
 * item they arrived in, or flat in the order the server returned them.
 */
export const ATTACHMENT_GROUPINGS = ["grouped", "flat"];
export const UI_DEFAULT_ATTACHMENT_GROUPING = "grouped";
/**
 * The complete persisted UI-preference contract. Mutations replace this small
 * value as one unit so adding an unrelated setting later cannot silently erase
 * a concurrently saved sidebar field.
 *
 * A field added after the contract shipped carries a default rather than being
 * required. The browser sends a complete snapshot, but the bundle that sends it
 * can be older than this schema — a cached one, a tab left open across a
 * deploy — and a strict object would answer that snapshot with a 400 and lose
 * the member's sidebar state along with it. Defaulting keeps the older client
 * working and leaves the output type total, so nothing downstream has to ask
 * whether the value is there.
 */
export const uiPreferencesSchema = z
    .object({
    sidebarCollapsed: z.boolean(),
    sidebarExpandedWidthPx: z
        .number()
        .int()
        .min(UI_SIDEBAR_MIN_WIDTH_PX)
        .max(UI_SIDEBAR_MAX_WIDTH_PX),
    attachmentGrouping: z
        .enum(ATTACHMENT_GROUPINGS)
        .default(UI_DEFAULT_ATTACHMENT_GROUPING),
})
    .strict();
export const defaultUiPreferences = Object.freeze({
    sidebarCollapsed: false,
    sidebarExpandedWidthPx: UI_SIDEBAR_DEFAULT_WIDTH_PX,
    attachmentGrouping: UI_DEFAULT_ATTACHMENT_GROUPING,
});
//# sourceMappingURL=ui-preferences.js.map